import Cookies from 'js-cookie';
import segmentTracking from '../../utilities/segmentTracking';
import {
  EMAIL_CAPTURE_COOKIE,
  EMAIL_SOURCE,
  EXPERIMENT_CONFIGS,
  EMAIL_CAPTURE_ALLOWED_PATHS,
  EMAIL_CAPTURE_BANNED_PATHS,
  EMAIL_CAPTURE_RULES,
  EMAIL_CAPTURE_CAMPAIGN,
  EMAIL_CAPTURE_DEFAULT_CONFIG,
  EMAIL_CAPTURE_PATH_CONFIGS,
} from './constants';

export function setCaptureModalCookie() {
  Cookies.set(EMAIL_CAPTURE_COOKIE, 'true', { expires: 365, path: '/' });
}

export function getCaptureModalCookieExists() {
  return !!Cookies.get(EMAIL_CAPTURE_COOKIE);
}

export function getExperiments(configs = EXPERIMENT_CONFIGS) {
  const experiments = {};
  Object.entries(configs).forEach(([experiment, { name, configs = {} }]) => {
    const variant = (window.experiments || {})[name];
    if (variant) {
      experiments[experiment] = {
        variant,
        ...(configs[variant] || {}),
      };
    }
  });
  return experiments;
}

/**
 * Tracks the A/B tested version on Segment
 * @param {string} eventName
 * @param {string} version
 */
export function trackEvent(eventName, experiments = {}) {

  const experimentVariants = {};
  Object.entries(experiments).forEach(([name, { variant }]) => {
    experimentVariants[name] = variant;
  });

  const properties = {
    ...experimentVariants,
    campaign: EMAIL_CAPTURE_CAMPAIGN,
  };

  segmentTracking.trackSegmentEvent(eventName, properties);
}

/**
 * Campaign Rules - function that takes a context and returns boolean indicating if
 * the rule has passed for the given context ('cdata' object in this case.)
 */
const CAMPAIGN_RULES = {
  isThirdParty(context) {
    return !!context.thirdParty;
  },

  isFirstTimeVisitor(context) {
    return context.visitorType === 'Net New';
  },

  isReturnVisitor(context) {
    return context.visitorType === 'Return Visitor';
  },

  hasCapturedEmail(context) {
    return !!(context.email && (context.emailSource == 'lytics' || context.emailSource == EMAIL_SOURCE));
  },

  hasEmail(context) {
    return !!context.email;
  },

  hasDismissedModal() {
    return getCaptureModalCookieExists();
  },

  hasPurchaseHistory(context) {
    return !!context.isCustomer;
  },

  hasCustomerId(context) {
    return !!context.cid;
  },
};

export function validateViewForEmailCapture(
  cdata,
  { rules = EMAIL_CAPTURE_RULES, allowed_paths = EMAIL_CAPTURE_ALLOWED_PATHS, banned_paths = EMAIL_CAPTURE_BANNED_PATHS } = {}
) {
  const areRulesValid = Object.entries(rules).every(([name, value]) => CAMPAIGN_RULES[name](cdata) === value);

  if (!areRulesValid) {
    return false;
  }

  const currentPathName = window.location.pathname;

  if (allowed_paths && allowed_paths.length) {
    const isRouteAllowed = allowed_paths.some(path => currentPathName.indexOf(path) === 0);
    if (!isRouteAllowed) {
      return false;
    }
  }

  if (banned_paths && banned_paths.length) {
    const isRouteBanned = banned_paths.some(path => currentPathName.indexOf(path) === 0);
    if (isRouteBanned) {
      return false;
    }
  }

  if (window.contentData && window.contentData.hideFreeShippingBanner) {
    return false;
  }

  return true;
}

export function getModalConfig() {
  if (!window) {
    return EMAIL_CAPTURE_DEFAULT_CONFIG;
  }
  const currentPathName = window.location.pathname;
  const { config } = EMAIL_CAPTURE_PATH_CONFIGS.find(({ paths }) => paths.some(path => currentPathName.indexOf(path) === 0)) || {};
  return config || EMAIL_CAPTURE_DEFAULT_CONFIG;
}
